// Create arrays of insurance and dietitian data
export const insuranceList = [
  { label: "United Healthcare", value: "united_healthcare", visible: true },
  { label: "Blue Cross Blue Shield", value: "blue_cross_blue_shield", visible: true },
  { label: "Anthem", value: "anthem", visible: true },
  { label: "Aetna", value: "aetna", visible: true },
  { label: "Cigna", value: "cigna", visible: true },
  { label: "Other", value: "other", visible: true },
  { label: "Medicare", value: "medicare", visible: false },
  { label: "Bold Leads", value: "bold_leads", visible: false },
] as const;

export const dietitianListStaging = [
  {
    name: "Svetlana Tuesday Morning",
    healthieId: "117964",
    insurances: ["blue_cross_blue_shield", "united_healthcare", "aetna", "cigna", "medicare", "other"],
  },
  {
    name: "Svetlana Wednesday",
    healthieId: "117996",
    insurances: ["blue_cross_blue_shield", "united_healthcare", "aetna", "cigna", "medicare", "other"],
  },
  {
    name: "Svetlana Thursday-Panteleyeva",
    healthieId: "117997",
    insurances: ["blue_cross_blue_shield", "united_healthcare", "aetna", "cigna", "medicare", "other"],
  },
  {
    name: "Felipe 1",
    healthieId: "590867",
    insurances: ["blue_cross_blue_shield", "united_healthcare", "aetna", "cigna", "medicare", "other"],
  },
] as const;

export const dietitianListWInsurance = [
  // { name: "Alexis Law", healthieId: "2172638", insurances: ["united_healthcare", "aetna", "cigna", "medicare"] },
  { name: "Amanda Stathos", healthieId: "3409140", insurances: ["aetna", "medicare"] },
  {
    name: "Amy Kay",
    healthieId: "2306849",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "aetna", "medicare"],
  },
  // { name: "Amy McCrea", healthieId: "3158445", insurances: ["united_healthcare", "aetna", "cigna", "medicare"] },
  {
    name: "Andrea Jones",
    healthieId: "1478316",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "cigna", "medicare"],
  },
  { name: "Andrea Soares", healthieId: "1728434", insurances: ["aetna", "medicare"] },
  {
    name: "Annette Snyder",
    healthieId: "2186317",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "cigna", "medicare"],
  },
  {
    name: "Aston Dommel",
    healthieId: "1507261",
    insurances: ["blue_cross_blue_shield", "anthem", "aetna", "cigna", "medicare"],
  },
  {
    name: "Bethany Deschamps",
    healthieId: "2764756",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "cigna"],
  },
  { name: "Christina Heath", healthieId: "2201322", insurances: ["united_healthcare", "medicare"] },
  { name: "Ciara Luisi", healthieId: "2116692", insurances: ["aetna", "medicare"] },
  {
    name: "Colette Micko",
    healthieId: "2034017",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "medicare"],
  },
  { name: "Courtney Pelitera", healthieId: "1527396", insurances: ["aetna", "cigna", "medicare"] },
  {
    name: "Crysta Pollitt",
    healthieId: "4764990",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "medicare"],
  },
  // {
  //   name: "Danielle D'Angelo",
  //   healthieId: "2979577",
  //   insurances: ["blue_cross_blue_shield", "anthem", "aetna", "cigna", "medicare"],
  // },
  { name: "Danielle Smith", healthieId: "1335780", insurances: ["aetna", "medicare"] },
  { name: "Deb Stegman", healthieId: "2012903", insurances: ["aetna", "cigna", "medicare"] },
  {
    name: "Destini Moody",
    healthieId: "1478317",
    insurances: ["blue_cross_blue_shield", "anthem", "aetna", "cigna", "medicare"],
  },
  { name: "Dina Garcia", healthieId: "2317518", insurances: ["blue_cross_blue_shield", "anthem", "cigna", "medicare"] },
  // { name: "Emily Wendt", healthieId: "1584168", insurances: ["united_healthcare", "medicare"] },
  {
    name: "Emma Anderskow",
    healthieId: "2151162",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "medicare"],
  },
  { name: "Emma Liu", healthieId: "1168412", insurances: ["united_healthcare", "aetna", "cigna", "medicare"] },
  { name: "Estelle Benoit", healthieId: "1434947", 
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "aetna", "cigna", "medicare"],
  },
  {
    name: "Greg Farris",
    healthieId: "1933237",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "medicare"],
  },
  { name: "Greta Kollmann", healthieId: "2013644", insurances: [] },
  {
    name: "Heidi Barbey",
    healthieId: "1847478",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "aetna", "cigna", "medicare"],
  },
  { name: "Jaclyn Leet", healthieId: "3053529", insurances: ["united_healthcare", "aetna", "cigna", "medicare"] },
  { name: "Janel Reeves", healthieId: "2873363", insurances: ["medicare"] },
  { name: "Jenna Limardo", healthieId: "1404190", insurances: ["united_healthcare"] },
  {
    name: "Jenny Janov",
    healthieId: "2097271",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "medicare"],
  },
  {
    name: "Jessie Anderson",
    healthieId: "2238935",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "aetna", "cigna", "medicare"],
  },
  { name: "Jessi Holden", healthieId: "2024494", insurances: ["blue_cross_blue_shield", "anthem"] },
  { name: "Joanne Tippin", healthieId: "2029699", insurances: ["united_healthcare", "aetna", "cigna", "medicare"] },
  {
    name: "Jordan Hill",
    healthieId: "1203886",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "aetna", "cigna", "medicare"],
  },
  { name: "Julie Usdavin", healthieId: "3075212", insurances: ["united_healthcare", "medicare"] },
  {
    name: "Justin Klein",
    healthieId: "1411836",
    insurances: ["blue_cross_blue_shield", "anthem", "aetna", "cigna", "medicare"],
  },
  {
    name: "Karin Evans",
    healthieId: "1344889",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "aetna", "medicare"],
  },
  {
    name: "Kathleen Benson",
    healthieId: "1805758",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "aetna", "cigna", "medicare"],
  },
  { name: "Katia Mashni", healthieId: "2116327", insurances: ["united_healthcare", "medicare"] },
  {
    name: "Kayla Barnes",
    healthieId: "2874046",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "aetna", "cigna", "medicare"],
  },
  // {
  //   name: "Kim Meeuwsen",
  //   healthieId: "1361835",
  //   insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "aetna", "cigna", "medicare"],
  // },
  {
    name: "Kim Trudel",
    healthieId: "1483654",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "aetna", "cigna", "medicare"],
  },
  {
    name: "Laura Ryan",
    healthieId: "2732288",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "aetna", "cigna", "medicare"],
  },
  // {
  //   name: "Lena Bakovic",
  //   healthieId: "1536013",
  //   insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "medicare"],
  // },
  // {
  //   name: "Libbi Calloway",
  //   healthieId: "1485584",
  //   insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "aetna", "cigna", "medicare"],
  // },
  {
    name: "Lisandra Cruz",
    healthieId: "2998649",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "medicare"],
  },
  {
    name: "Lori Barrett",
    healthieId: "1540166",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "aetna", "cigna", "medicare"],
  },
  { name: "Luciana Ambrosi", healthieId: "2849338", insurances: ["united_healthcare", "cigna", "medicare"] },
  // {
  //   name: "Manju Karkare",
  //   healthieId: "1221206",
  //   insurances: ["blue_cross_blue_shield", "anthem", "aetna", "cigna", "medicare"],
  // },
  { name: "Marlyne Perez", healthieId: "2857432", insurances: ["united_healthcare", "medicare"] },
  { name: "Matt Abel", healthieId: "2010362", insurances: ["medicare"] },
  {
    name: "Matt Jacobs",
    healthieId: "2606144",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "medicare"],
  },
  { name: "Megan Callahan", healthieId: "1827731", insurances: ["medicare"] },
  { name: "Megan Hilbert", healthieId: "1524716", insurances: ["united_healthcare", "medicare"] },
  // {
  //   name: "Melissa Galich",
  //   healthieId: "2310335",
  //   insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "aetna", "cigna", "medicare"],
  // },
  {
    name: "Michelle Rodgers",
    healthieId: "1197103",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "aetna", "cigna", "medicare"],
  },
  {
    name: "Mikelanne Phaneuf",
    healthieId: "1431661",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "aetna", "cigna", "medicare"],
  },
  {
    name: "Nicolette Maggiolo",
    healthieId: "1119248",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "aetna", "cigna", "medicare"],
  },
  { name: "Rebecca Dillon", healthieId: "3180836", insurances: ["medicare"] },
  {
    name: "Rosa Becerra",
    healthieId: "1575333",
    insurances: ["blue_cross_blue_shield", "anthem", "aetna", "medicare"],
  },
  {
    name: "Rose Britt",
    healthieId: "2896395",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "medicare"],
  },
  { name: "Sarah Keathley", healthieId: "2280192", insurances: ["united_healthcare", "aetna", "cigna", "medicare"] },
  { name: "Shelby Love", healthieId: "3197516", insurances: ["united_healthcare", "aetna", "cigna", "medicare"] },
  { name: "Tami Best", healthieId: "1423767", insurances: ["blue_cross_blue_shield", "anthem", "aetna", "medicare"] },
  {
    name: "Taylor Johnson",
    healthieId: "2672677",
    insurances: ["blue_cross_blue_shield", "anthem", "aetna", "cigna", "medicare"],
  },
  {
    name: "Taylor Larsen",
    healthieId: "2971081",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "aetna", "cigna", "medicare"],
  },
  { name: "Tim DiLeo", healthieId: "2370674", insurances: ["united_healthcare", "aetna"] },
  {
    name: "Tonya Turner",
    healthieId: "1451394",
    insurances: ["blue_cross_blue_shield", "anthem", "cigna", "medicare"],
  },
  {
    name: "Tracy Betz",
    healthieId: "2371950",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "aetna", "cigna", "medicare"],
  },
  {
    name: "Valentina Lemes",
    healthieId: "2874526",
    insurances: ["united_healthcare", "blue_cross_blue_shield", "anthem", "aetna", "cigna", "medicare"],
  },
];

export const excludeCashIdsStaging = ["117997"];

export const excludeCashIds = [
  // "1536013",
  "2896395",
  "1344889",
  "1221206",
  "4764990",
  "1197103",
  "2116692",
  "1168412",
  "1483654",
  "3409140",
  "1411836",
];

export const licenseStateException = [
  "AZ",
  "CA",
  "CO",
  "CT",
  "HI",
  "IN",
  "MI",
  "NJ",
  "NY",
  "OR",
  "PA",
  "TX",
  "VT",
  "VA",
  "WA",
  "WI",
  "AR",
  // can match but must apply for licensur asap
  // "FL",
  // "GA",
  // "IL",
  // "LA",
  // "MD",
  "MS",
  "ND",
  // "SC",
];

export const defaultProvidersProd: string[] = ["1197103", "1540166"];

export const defaultProvidersStaging: string[] = ["117964", "590867", "997138", "117997"];
